// extracted by mini-css-extract-plugin
export var createdDate = "_ne-1";
export var divider = "_ne-2";
export var headerDivider = "_ne-3";
export var messagesCard = "_ne-0";
export var messagesContainer = "_ne-7";
export var messagesContainerWrapper = "_ne-4";
export var pointerCapturingButtonBoxes = "_ne-a";
export var showLeftPanelButton = "_ne-9";
export var showMoreButton = "_ne-c";
export var showMoreButtonContainer = "_ne-b";
export var summaryTitle = "_ne-6";
export var systemMessageCardWrapper = "_ne-d";
export var topButtons = "_ne-8";
export var withPadding = "_ne-5";